import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";

export const query = gql`
    query project ($projectId: Int) {
        project(pid: $projectId) {
            config
            name
            active
        }
    }
`

export const createProjectConfig = gql`
    mutation updateProjectConfig($pid: Int!, $config: JSONString!) {
        updateProjectConfig(pid: $pid, config: $config) {
            project {
                pid,
                config
            }
        }
}`

export const withDataAndErrors = compose(
    graphql(createProjectConfig, {
    name: "CreateProjectConfig"
    }),
    graphql(query,{
        options: (props) => ({
            variables: {
                projectId: props.match.params.id
            },
            errorPolicy: "all",
            fetchPolicy: 'network'
        }),
        name: "project"
    })

);



// WEBPACK FOOTER //
// ./src/views/projectconfig/graph.js